// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("../../assets/arrow-right-purple.svg", import.meta.url);
// Module
var code = `<section class="unete"
    id="unete">
    <div class="container container--space">
        <div class="row unete__row">

            <!-- Imagen -->
            <div class="col-lg-6 unete__image order-lg-12">
                <img ng-src="{{\$ctrl.unete.image}}"
                    alt="{{\$ctrl.unete.title}}">
            </div>

            <!-- Header (en lg pasa arriba) -->
            <div class="col-12 unete__header text-center">
                <h2 class="unete__title">
                    {{\$ctrl.unete.title}}
                </h2>
                <h3 ng-bind-html="\$ctrl.unete.intro"
                    class="unete__intro">
                </h3>
            </div>

            <!-- Contenido -->
            <div class="col-lg-6 unete__content">

                <div class="d-none unete__description d-lg-block"
                    ng-bind-html="\$ctrl.unete.description">

                </div>
                <!-- Pasos: No cliente -->
                <ul class="unete__steps">
                    <li class="unete__step"
                        ng-repeat="step in \$ctrl.unete.paths.noClient.steps">

                        <span class="unete__step-number">
                            {{step.step}}
                        </span>

                        <div>
                            <h4 class="unete__step-title">
                                {{step.title}}
                            </h4>

                            <p class="unete__step-text">
                                {{step.subtitle}}
                            </p>
                        </div>

                    </li>
                </ul>

                <!-- CTA cliente -->
                <a class="link-global link-global--fade"
                    href="#activar"
                    class="unete__cta">
                    {{\$ctrl.unete.paths.client.label}}
                    <img src="${___HTML_LOADER_IMPORT_0___}"
                        alt="flecha derecha">
                </a>
            </div>

        </div>
    </div>
</section>`;
// Exports
export default code;